import React, { useState, useEffect } from 'react';
import axios from 'axios';

const LocationTracker = ({ onDistrictUpdate }) => {
  const [location, setLocation] = useState(null);
  const [district, setDistrict] = useState('');
  const [error, setError] = useState(null);

  // Function to get the stored district from localStorage or fetch a new one
  const getStoredDistrict = () => {
    const storedDistrict = localStorage.getItem('district');
    if (storedDistrict) {
      setDistrict(storedDistrict);
      onDistrictUpdate(storedDistrict);  // Notify parent about the district update
    } else {
      // If not found in localStorage, fetch the district
      fetchLocationAndDistrict();
    }
  };

  useEffect(() => {
    getStoredDistrict();

    // Set an interval to update location and district every 10 minutes
    const interval = setInterval(() => {
      fetchLocationAndDistrict();
    }, 600000); // 600000 ms = 10 minutes

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  // Function to get the user's location and fetch the district
  const fetchLocationAndDistrict = () => {
    if (navigator.geolocation) {
      // Check current permission status
      navigator.permissions.query({ name: 'geolocation' })
        .then(permissionStatus => {
          if (permissionStatus.state === 'granted') {
            // If permission is granted, get location
            navigator.geolocation.getCurrentPosition(
              (position) => {
                const lat = position.coords.latitude;
                const lon = position.coords.longitude;
                setLocation({ lat, lon });

                // Fetch the district using reverse geocoding
                fetchDistrict(lat, lon);
              },
              (err) => {
                setError('Error getting location');
                console.log(err);
              }
            );
          } else if (permissionStatus.state === 'prompt') {
            // If permission is 'prompt', request permission
            navigator.geolocation.getCurrentPosition(
              (position) => {
                const lat = position.coords.latitude;
                const lon = position.coords.longitude;
                setLocation({ lat, lon });

                // Fetch the district using reverse geocoding
                fetchDistrict(lat, lon);
              },
              (err) => {
                setError('Error getting location');
                console.log(err);
              }
            );
          } else {
            // Handle the case where permission is denied
            setError('Location permission denied');
          }
        })
        .catch((error) => {
          console.error(error);
          setError('Failed to check location permissions');
        });
    } else {
      setError('Geolocation not supported');
    }
  };

  // Function to fetch the district from Nominatim API
  const fetchDistrict = async (lat, lon) => {
    try {
      const response = await axios.get(`https://nominatim.openstreetmap.org/reverse`, {
        params: {
          lat: lat,
          lon: lon,
          format: 'json',
          addressdetails: 1,
        },
      });

      // Extract the district from the response
      const address = response.data.address;
      if (address && address.city_district) {
        const district = address.city_district;
        setDistrict(district);
        localStorage.setItem('district', district); // Save to localStorage
        onDistrictUpdate(district);  // Notify parent about the district update
      } else if (address && address.state_district) {
        const district = address.state_district;
        setDistrict(district);
        localStorage.setItem('district', district); // Save to localStorage
        onDistrictUpdate(district);  // Notify parent about the district update
      } else {
        setDistrict('District not found');
        localStorage.removeItem('district'); // Clear stored data if no district found
        onDistrictUpdate('District not found');  // Notify parent about the update
      }
    } catch (error) {
      console.error(error);
      setError('Failed to fetch district');
      localStorage.removeItem('district'); // Clear stored data in case of error
      onDistrictUpdate('Failed to fetch district');  // Notify parent about the update
    }
  };

  return null; // This component does not render anything itself
};

export default LocationTracker;